var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileTextLine = function SvgFileTextLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.75 7v9.745a.75.75 0 0 1-.745.755H3.995a.745.745 0 0 1-.745-.744V3.244c0-.403.337-.744.752-.744h8.246zm-1.5.75H11.5V4H4.75v12h10.5zM7 6.25h2.25v1.5H7zm0 3h6v1.5H7zm0 3h6v1.5H7z"
  })));
};
export default SvgFileTextLine;